/* eslint-disable */
import { APIClient } from "./_api";

const endpoint = "/User";

export function login(data) {
  return APIClient.post(`${endpoint}/login`, data);
}

export function handleLoginByUser(data) {
  return APIClient.post(`${endpoint}/loginByAnotherUser`, data);
}

export function getMe() {
  return APIClient.get(`${endpoint}/me`);
}

export function heiringSignup(data) {
  return APIClient.post(`${endpoint}/heiring/signup`, data);
}

export function isAssistantLink(values) {
  return APIClient.post(`${endpoint}/checkReferral`, values);
}

export function loginFacebook(data) {
  return APIClient.post(`${endpoint}/facebook/login`, data);
}
export function registerFacebook(data) {
  return APIClient.post(`${endpoint}/facebook/register`, data);
}
export function connectFacebook(data) {
  return APIClient.post(`${endpoint}/facebook/connect`, data);
}

export function completeProfile(data) {
  return APIClient.put(`/AppliedAgent/application`, data);
}
export function completeProfileAssistant(data) {
  return APIClient.put(`${endpoint}/facebook/complete`, data);
}

// export function applicationAgent(data) {
//   return APIClient.post(`${endpoint}/application/agent`, data);
// }

// export function applicationAgent(data) {
//   return APIClient.post(`${endpoint}/application/agent`, data);
// }
export function applicationAgent(data) {
  return APIClient.post(`/AppliedAgent/application`, data);
}

export function forgetPassword(data) {
  return APIClient.post(`${endpoint}/forgetPassword`, data);
}

export function editProfile(data) {
  return APIClient.put(`${endpoint}`, data);
}
export function getInveiteLink() {
  return APIClient.get(`${endpoint}/InviteLink`);
}
export function getPage() {
  return APIClient.get(`${endpoint}/InviteLink/getQuote`);
}

export function getInveiteLinkAssistant() {
  return APIClient.get(`${endpoint}/InviteLink/assistant`);
}

export function addImg(value, func) {
  const bodyFormData = new FormData();
  for (const key in value) {
    bodyFormData.append(key, value[key]);
  }
  return APIClient.put(`${endpoint}/avatar`, bodyFormData, {
    onUploadProgress(progress) {
      if (func) {
        func(progress);
      }
    },
  });
}
